import { render, staticRenderFns } from "./hls-video.vue?vue&type=template&id=48abb60d&scoped=true"
import script from "./hls-video.vue?vue&type=script&lang=js"
export * from "./hls-video.vue?vue&type=script&lang=js"
import style0 from "./hls-video.vue?vue&type=style&index=0&id=48abb60d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48abb60d",
  null
  
)

export default component.exports